export default {
      id: "dot-usage",
      viewBox: "0 0 14 14",
      url: "/assets/" + "icons.svg#dot",
      toString: function () {
        return this.url;
      }
    }